// ============================================================================
// SharedModule - Common UI Components & PrimeNG Re-exports
// ============================================================================
// Imported by every feature module. Exports PrimeNG table/dialog/button/toast
// modules plus shared components (FavoriteIcon, OrderProgressBar, QuoteStatus,
// Availability, ProductPrice, BuyButton, FileDrop). Replaces V1's directives.
// ============================================================================

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// PrimeNG modules
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TextareaModule } from 'primeng/textarea';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { PaginatorModule } from 'primeng/paginator';
import { DatePickerModule } from 'primeng/datepicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

// Shared components
import { FavoriteIconComponent } from './components/favorite-icon/favorite-icon.component';
import { OrderProgressBarComponent } from './components/order-progress-bar/order-progress-bar.component';
import { QuoteStatusComponent } from './components/quote-status/quote-status.component';
import { AvailabilityComponent } from './components/availability/availability.component';
import { ProductPriceComponent } from './components/product-price/product-price.component';
import { BuyButtonComponent } from './components/buy-button/buy-button.component';
import { FileDropComponent } from './components/file-drop/file-drop.component';

const PRIMENG_MODULES = [
  TableModule,
  ButtonModule,
  DialogModule,
  RadioButtonModule,
  TextareaModule,
  InputTextModule,
  ProgressBarModule,
  SelectModule,
  TooltipModule,
  TagModule,
  ToastModule,
  PaginatorModule,
  DatePickerModule,
  ConfirmDialogModule
];

@NgModule({
  declarations: [
    FavoriteIconComponent,
    OrderProgressBarComponent,
    QuoteStatusComponent,
    AvailabilityComponent,
    ProductPriceComponent,
    BuyButtonComponent,
    FileDropComponent
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, ...PRIMENG_MODULES],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ...PRIMENG_MODULES,
    FavoriteIconComponent,
    OrderProgressBarComponent,
    QuoteStatusComponent,
    AvailabilityComponent,
    ProductPriceComponent,
    BuyButtonComponent,
    FileDropComponent
  ]
})
export class SharedModule {}
